module.exports = __webpack_public_path__ + "assets/9e8e5c64eb053ea042ad0c1c71638c0b.png";